/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import '../../../common/currency_codes';
import './session';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "cash": {
        "nested": {
          "grantly": {
            "nested": {
              "api": {
                "nested": {
                  "Action": {
                    "fields": {
                      "type": {
                        "type": "squareup.cash.grantly.api.Action.Type",
                        "id": 1,
                        "rule": "optional"
                      },
                      "oneTimePayment": {
                        "type": "squareup.cash.grantly.api.Action.OneTimePayment",
                        "id": 2
                      },
                      "onFilePayment": {
                        "type": "squareup.cash.grantly.api.Action.OnFilePayment",
                        "id": 3
                      },
                      "unlinkedRefund": {
                        "type": "squareup.cash.grantly.api.Action.UnlinkedRefund",
                        "id": 4
                      },
                      "linkAccount": {
                        "type": "squareup.cash.grantly.api.Action.LinkAccount",
                        "id": 5
                      },
                      "sessionAuthentication": {
                        "type": "squareup.cash.grantly.api.Action.SessionAuthentication",
                        "id": 6
                      },
                      "recurringDeposits": {
                        "type": "squareup.cash.grantly.api.Action.RecurringDeposits",
                        "id": 7
                      },
                      "onFileDeposit": {
                        "type": "squareup.cash.grantly.api.Action.OnFileDeposit",
                        "id": 8
                      },
                      "shadowAccount": {
                        "type": "squareup.cash.grantly.api.Action.ShadowAccount",
                        "id": 9
                      },
                      "oauthReadTransaction": {
                        "type": "squareup.cash.grantly.api.Action.OAuthReadTransactions",
                        "id": 10
                      }
                    },
                    "nested": {
                      "Type": {
                        "values": {
                          "ONE_TIME_PAYMENT": 1,
                          "ON_FILE_PAYMENT": 2,
                          "UNLINKED_REFUND": 3,
                          "LINK_ACCOUNT": 4,
                          "SESSION_AUTHENTICATION": 5,
                          "RECURRING_DEPOSITS": 6,
                          "ON_FILE_DEPOSIT": 7,
                          "SHADOW_ACCOUNT": 8,
                          "OAUTH_READ_TRANSACTIONS": 9
                        }
                      },
                      "OneTimePayment": {
                        "fields": {
                          "amount": {
                            "type": "uint64",
                            "id": 1,
                            "rule": "optional"
                          },
                          "currency": {
                            "type": "squareup.common.CurrencyCode",
                            "id": 2,
                            "rule": "optional"
                          },
                          "scopeId": {
                            "type": "string",
                            "id": 4,
                            "rule": "optional"
                          },
                          "orderId": {
                            "type": "string",
                            "id": 5,
                            "rule": "optional"
                          },
                          "checkoutOptions": {
                            "type": "squareup.cash.grantly.api.Action.OneTimePayment.CheckoutOptions",
                            "id": 6,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "CheckoutOptions": {
                            "fields": {
                              "automaticDiscounts": {
                                "type": "bool",
                                "id": 1,
                                "rule": "optional"
                              },
                              "scopeOptions": {
                                "type": "squareup.cash.grantly.api.Action.ScopeOptions",
                                "id": 2,
                                "rule": "optional"
                              }
                            }
                          }
                        }
                      },
                      "OnFilePayment": {
                        "fields": {
                          "scopeId": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "accountReferenceId": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "context": {
                            "type": "squareup.cash.grantly.api.Action.OnFilePayment.Context",
                            "id": 3,
                            "rule": "optional"
                          },
                          "checkoutOptions": {
                            "type": "squareup.cash.grantly.api.Action.OnFilePayment.CheckoutOptions",
                            "id": 4,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "Context": {
                            "fields": {
                              "orderId": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              }
                            }
                          },
                          "CheckoutOptions": {
                            "fields": {
                              "scopeOptions": {
                                "type": "squareup.cash.grantly.api.Action.ScopeOptions",
                                "id": 1,
                                "rule": "optional"
                              }
                            }
                          }
                        }
                      },
                      "UnlinkedRefund": {
                        "fields": {
                          "amount": {
                            "type": "uint64",
                            "id": 1,
                            "rule": "optional"
                          },
                          "currency": {
                            "type": "squareup.common.CurrencyCode",
                            "id": 2,
                            "rule": "optional"
                          },
                          "scopeId": {
                            "type": "string",
                            "id": 4,
                            "rule": "optional"
                          }
                        }
                      },
                      "LinkAccount": {
                        "fields": {
                          "primaryAlias": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "secondaryAlias": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "SessionAuthentication": {
                        "fields": {
                          "scopes": {
                            "type": "squareup.cash.grantly.api.SessionScope",
                            "id": 1,
                            "rule": "repeated"
                          },
                          "associatedRequestId": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "associatedRedirectUrl": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      },
                      "RecurringDeposits": {
                        "fields": {
                          "primaryAlias": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "logoUrl": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "accountReferenceId": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      },
                      "OnFileDeposit": {
                        "fields": {
                          "scopeId": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "accountReferenceId": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "ShadowAccount": {
                        "fields": {}
                      },
                      "OAuthReadTransactions": {
                        "fields": {}
                      },
                      "ScopeOptions": {
                        "fields": {
                          "risky": {
                            "type": "bool",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "details": {
                        "oneof": ["oneTimePayment", "onFilePayment", "unlinkedRefund", "linkAccount", "sessionAuthentication", "recurringDeposits", "onFileDeposit", "shadowAccount", "oauthReadTransaction"]
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.Action && !$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.Action?.nested?.Type && !$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.Action?.nested?.OneTimePayment && !$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.Action?.nested?.OneTimePayment?.nested?.CheckoutOptions && !$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.Action?.nested?.OnFilePayment && !$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.Action?.nested?.OnFilePayment?.nested?.Context && !$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.Action?.nested?.OnFilePayment?.nested?.CheckoutOptions && !$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.Action?.nested?.UnlinkedRefund && !$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.Action?.nested?.LinkAccount && !$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.Action?.nested?.SessionAuthentication && !$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.Action?.nested?.RecurringDeposits && !$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.Action?.nested?.OnFileDeposit && !$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.Action?.nested?.ShadowAccount && !$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.Action?.nested?.OAuthReadTransactions && !$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.Action?.nested?.ScopeOptions) {
  $root.addJSON(jsonData);
}

/**
 * Represents an intent from a third-party client to perform the contained
 * operation.
 *
 * SOURCE Action @ squareup/cash/grantly/api/action.proto at 14:1
 */
export const Action = $root.lookupType('squareup.cash.grantly.api.Action');
fixType(Action);
Builder.createAndAttachToType(Action);
/**
 * ///////////////////////////////////////////////////////////////////////////
 * ALL ACTION TYPE DATA GOES BELOW THIS LINE
 * Represents the type of action and what details are contained in the action
 * payload.
 *
 * SOURCE Type @ squareup/cash/grantly/api/action.proto at 84:3
 */
Action.Type = $root.lookupEnum('squareup.cash.grantly.api.Action.Type').values;
/**
 * Represents an intent for a third-party to charge a Cash customer on behalf
 * of a merchant.
 *
 * - Associated with `ONE_TIME` use grants.
 *
 * SOURCE OneTimePayment @ squareup/cash/grantly/api/action.proto at 139:3
 */
Action.OneTimePayment = $root.lookupType('squareup.cash.grantly.api.Action.OneTimePayment');
fixType(Action.OneTimePayment);
Builder.createAndAttachToType(Action.OneTimePayment);
/**
 * Next ID: 7
 * Describes the different options partners can configure while a customer is checking out with Cash App Pay.
 *
 * SOURCE CheckoutOptions @ squareup/cash/grantly/api/action.proto at 190:5
 */
Action.OneTimePayment.CheckoutOptions = $root.lookupType('squareup.cash.grantly.api.Action.OneTimePayment.CheckoutOptions');
fixType(Action.OneTimePayment.CheckoutOptions);
Builder.createAndAttachToType(Action.OneTimePayment.CheckoutOptions);
/**
 * Represents an intent for a third-party to repeatedly charge or refund a
 * Cash customer on behalf of a merchant.
 *
 * - Associated with `EXTENDED` use grants.
 *
 * SOURCE OnFilePayment @ squareup/cash/grantly/api/action.proto at 209:3
 */
Action.OnFilePayment = $root.lookupType('squareup.cash.grantly.api.Action.OnFilePayment');
fixType(Action.OnFilePayment);
Builder.createAndAttachToType(Action.OnFilePayment);
/**
 * Data that will not be persisted onto the grant,
 * but used for enhanced UX purposes within the request approval flow.
 * These enhancements could include: order amounts/totals, shipping information, order details.
 *
 * SOURCE Context @ squareup/cash/grantly/api/action.proto at 240:5
 */
Action.OnFilePayment.Context = $root.lookupType('squareup.cash.grantly.api.Action.OnFilePayment.Context');
fixType(Action.OnFilePayment.Context);
Builder.createAndAttachToType(Action.OnFilePayment.Context);
/**
 * Describes the different options partners can configure while a customer is checking out with Cash App Pay.
 *
 * SOURCE CheckoutOptions @ squareup/cash/grantly/api/action.proto at 256:5
 */
Action.OnFilePayment.CheckoutOptions = $root.lookupType('squareup.cash.grantly.api.Action.OnFilePayment.CheckoutOptions');
fixType(Action.OnFilePayment.CheckoutOptions);
Builder.createAndAttachToType(Action.OnFilePayment.CheckoutOptions);
/**
 * Represents an intent for a third-party to issue an unlinked refund to a
 * Cash customer on behalf of a merchant.
 *
 * - Associated with `ONE_TIME` use grants.
 *
 * SOURCE UnlinkedRefund @ squareup/cash/grantly/api/action.proto at 272:3
 */
Action.UnlinkedRefund = $root.lookupType('squareup.cash.grantly.api.Action.UnlinkedRefund');
fixType(Action.UnlinkedRefund);
Builder.createAndAttachToType(Action.UnlinkedRefund);
/**
 * SOURCE LinkAccount @ squareup/cash/grantly/api/action.proto at 310:3
 */
Action.LinkAccount = $root.lookupType('squareup.cash.grantly.api.Action.LinkAccount');
fixType(Action.LinkAccount);
Builder.createAndAttachToType(Action.LinkAccount);
/**
 * SOURCE SessionAuthentication @ squareup/cash/grantly/api/action.proto at 332:3
 */
Action.SessionAuthentication = $root.lookupType('squareup.cash.grantly.api.Action.SessionAuthentication');
fixType(Action.SessionAuthentication);
Builder.createAndAttachToType(Action.SessionAuthentication);
/**
 * SOURCE RecurringDeposits @ squareup/cash/grantly/api/action.proto at 355:3
 */
Action.RecurringDeposits = $root.lookupType('squareup.cash.grantly.api.Action.RecurringDeposits');
fixType(Action.RecurringDeposits);
Builder.createAndAttachToType(Action.RecurringDeposits);
/**
 * SOURCE OnFileDeposit @ squareup/cash/grantly/api/action.proto at 384:3
 */
Action.OnFileDeposit = $root.lookupType('squareup.cash.grantly.api.Action.OnFileDeposit');
fixType(Action.OnFileDeposit);
Builder.createAndAttachToType(Action.OnFileDeposit);
/**
 * Represents the intent to create and maintain a shadow or cash-app managed account
 *  on Afterpay.
 *
 * SOURCE ShadowAccount @ squareup/cash/grantly/api/action.proto at 414:3
 */
Action.ShadowAccount = $root.lookupType('squareup.cash.grantly.api.Action.ShadowAccount');
fixType(Action.ShadowAccount);
Builder.createAndAttachToType(Action.ShadowAccount);
/**
 * OAuth Scope for reading a customer's transactions.
 *
 * SOURCE OAuthReadTransactions @ squareup/cash/grantly/api/action.proto at 421:3
 */
Action.OAuthReadTransactions = $root.lookupType('squareup.cash.grantly.api.Action.OAuthReadTransactions');
fixType(Action.OAuthReadTransactions);
Builder.createAndAttachToType(Action.OAuthReadTransactions);
/**
 * SOURCE ScopeOptions @ squareup/cash/grantly/api/action.proto at 425:3
 */
Action.ScopeOptions = $root.lookupType('squareup.cash.grantly.api.Action.ScopeOptions');
fixType(Action.ScopeOptions);
Builder.createAndAttachToType(Action.ScopeOptions);